const CONTENT_TYPES = {
  ARTICLE: 'article',
  GUIDE: 'guide',
  INCIDENT_GUIDE: 'incident_guide',
  SELF_TEST: 'self_test',
};

export default CONTENT_TYPES;
